export const ENTER_KEY = 13
export const ESCAPE_KEY = 27;
export const DELETE_KEY = 46;
export const INSERT_KEY = 45;

export const PAGE_UP_KEY = 33
export const PAGE_DOWN_KEY = 34
export const END_KEY = 35
export const HOME_KEY = 36

export const LEFT_ARROW_KEY = 37
export const UP_ARROW_KEY = 38
export const RIGHT_ARROW_KEY = 39
export const DOWN_ARROW_KEY = 40

export const BACKSCAPE_KEY = 8;

export const PLUS_KEY = 107;
export const MINUS_KEY = 109;